import { z } from "zod";

export const LiabilityRatePer = z.enum(["Hundred", "Thousand"]);

export type LiabilityRatePerEnum = z.infer<typeof LiabilityRatePer>;

export const LiabilityRatePerDisplayName: Record<LiabilityRatePerEnum, string> =
  {
    [LiabilityRatePer.enum.Hundred]: "Hundreds",
    [LiabilityRatePer.enum.Thousand]: "Thousands",
  };
